import {InputTextV2} from '@prtimes-basis/input';
import styles from './address2-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function Address2Field() {
  return (
    <FormField.Root name='billingInfo.address2'>
      <div className={styles.container}>
        <Body />

        <FormField.Error />
      </div>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <>
      <label
        htmlFor={fieldProps.id}
        className={companyRegistrationPageStyles.srOnly}
      >
        請求先住所（建物名 / 階数）
      </label>

      <InputTextV2 placeholder='住所（建物名 / 階数）' {...fieldProps} />
    </>
  );
}
